import React from 'react';
import PropTypes from 'prop-types';
import RecipientEditDesktop from './RecipientEditDesktop';
import RecipientEditMobile from './RecipientEditMobile';
import RecipientShow from './RecipientShow';
import { Dthc } from '../../../Modules';

const RecipientComponent = ({
  canEdit,
  localRecipient,
  onChange,
  resetRecipient,
  recipient,
  updateRecipient
}) =>
  <div>
    {canEdit &&
      <Dthc
        desktop={RecipientEditDesktop}
        mobile={RecipientEditMobile}
        reset={resetRecipient}
        onChange={onChange}
        commitUpdate={updateRecipient}
        localRecipient={localRecipient}
      >
        <RecipientShow recipient={recipient} />
      </Dthc>}
    {!canEdit && <RecipientShow recipient={recipient} readOnly />}
  </div>;

RecipientComponent.propTypes = {
  canEdit: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  localRecipient: PropTypes.object.isRequired,
  resetRecipient: PropTypes.func.isRequired,
  recipient: PropTypes.object.isRequired,
  updateRecipient: PropTypes.func.isRequired
};

export default RecipientComponent;



// WEBPACK FOOTER //
// ./webpack/components/Document/Sections/Recipient/Recipient.js